

module.exports = __webpack_require__.stylable.create(
    "spacing228907719",
    {"classes":{"root":"spacing228907719__root"},"vars":{},"stVars":{"spacing01":"1px","spacing02":"2px","spacing03":"3px","spacing06":"6px","spacing12":"12px","spacing18":"18px","spacing24":"24px","spacing30":"30px","spacing36":"36px","spacing42":"42px","spacing48":"48px","spacing78":"78px","spacing90":"90px","Spacing":"6px","SP1":"calc(6px * 1)","SP2":"calc(6px * 2)","SP3":"calc(6px * 3)","SP4":"calc(6px * 4)","SP5":"calc(6px * 5)","SP6":"calc(6px * 6)","SP7":"calc(6px * 7)","SP8":"calc(6px * 8)","SP9":"calc(6px * 9)","SP10":"calc(6px * 10)"},"keyframes":{}},
    "",
    1,
    "spacing228907719",
    __webpack_require__.stylable.$
);
